<template>
  <div>
    <portal to="sidebar-menu">
      <div>
        <nav-list :items="navigationItems"></nav-list>
        <text-language-select/>
      </div>
    </portal>

    <div class="row d-flex justify-content-between">
      <div class="col-12">
        <router-view></router-view>
      </div>
    </div>
    <div>

    </div>
  </div>
</template>
<script>
  import TextLanguageSelect from 'src/components/TextLanguageSelect'
  export default {
    name: 'settings',
    components: {
      TextLanguageSelect
    },
    data() {
      return {
        navigationItems: [
          {
            type: 'group',
            name: this.$t('generic.general')
          },
          {
            routeName: 'settings_general',
            name: this.$t('settings.general.title')
          },
          {
            routeName: 'settings_third-parties',
            name: this.$t('settings.thirdParties.title')
          },
          {
            routeName: 'settings_country',
            name: this.$t('settings.country.title'),
          },
          {
            routeName: 'settings_language',
            name: this.$t('settings.language.title')
          },
          {
            routeName: 'settings_site-admins',
            name: this.$t('settings.siteAdmins.title'),
          },
          {
            routeName: 'settings_roles',
            name: this.$t('settings.roles.title')
          },
          {
            type: 'group',
            name: this.$t('generic.email')
          },
          {
            routeName: 'settings_email',
            name: this.$t('settings.emails.title')
          },
          {
            routeName: 'settings_email-configuration',
            name: this.$t('settings.emailConfiguration.title')
          },
          {
            routeName: 'settings_email-schedule',
            name: this.$t('settings.emailSchedule.title')
          },
          {
            routeName: 'settings_translations',
            name: this.$t('settings.translations.title'),
            hide: !this.$can('admin-wip')
          },
          {
            type: 'group',
            name: this.$t('generic.ecommerce')
          },
          {
            routeName: 'settings_custom_fields',
            name: this.$t('settings.customFields.title'),
            hide: !this.$can('admin-wip'),
          },
          {
            routeName: 'settings_products',
            name: this.$t('settings.products.title')
          },
          {
            routeName: 'settings_payment-types',
            name: this.$t('settings.payments.title')
          },
          {
            routeName: 'settings_e_commerce',
            name: this.$t('settings.ecommerce.title'),
          },
          {
            type: 'group',
            name: this.$t('settings.jobs.title')
          },
          {
            routeName: 'settings_job',
            name: this.$t('settings.jobs.title')
          },
          {
            routeName: 'settings_search-suggestions',
            name: this.$t('settings.searchSuggestions.title')
          },
          {
            routeName: 'settings_segments-groups',
            name: this.$t('settings.segments.title'),
          },
          {
            type: 'group',
            name: this.$t('settings.candidates.title')
          },
          {
            routeName: 'settings_candidate',
            name: this.$t('settings.candidates.settings.title')
          },
        ]
      }
    },
  }
</script>
